import { NgModule } from '@angular/core';
import { DetailsContainerComponent } from './containers/details.container';
import { CandidateDetailsCardComponent } from './components/candidate-details-card/candidate-details-card.component';
import { CandidateResumeCardComponent } from './components/candidate-resume-card/candidate-resume-card.component';
import { CandidateEducationCardComponent } from './components/candidate-education-card/candidate-education-card.component';
import { CandidateCertificationsCardComponent } from '@modules/candidates/child-modules/details/components/candidate-certifications-card/candidate-certifications-card.component';
import { CandidateAchievementsCardComponent } from './components/candidate-achievements-card/candidate-achievements-card.component';
import { CandidatePdfResumeCardComponent } from '@modules/candidates/child-modules/details/components/candidate-pdf-resume-card/candidate-pdf-resume-card.component';
import { CandidateSkillsCardComponent } from '@modules/candidates/child-modules/details/components/candidate-skills-card/candidate-skills-card.component';
import { CommonModule } from '@angular/common';
import { MojoCardModule } from 'mojo-card';
import { SharedModule } from '@shared';
import { EffectsModule } from '@ngrx/effects';
import { CandidatesEffects, candidatesPageReducers } from '@modules/candidates/store';
import { StoreModule } from '@ngrx/store';
import { MojoExpandibleCardComponent } from './components/mojo-expandible-card/mojo-expandible-card.component';
import { CandidateSkillComponent } from './components/candidate-skill/candidate-skill.component';
import { MojoExpandableCardModule } from 'mojo-expandable-card';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { CandidateResumeCardHeaderComponent } from './components/candidate-resume-card-header/candidate-resume-card-header.component';
import { PdfViewerAdapterModule } from '@shared/pdf-viewer-adapter/pdf-viewer-adapter.module';

const components = [
  DetailsContainerComponent,
  CandidateDetailsCardComponent,
  CandidateResumeCardComponent,
  CandidateEducationCardComponent,
  CandidateCertificationsCardComponent,
  CandidateAchievementsCardComponent,
  CandidatePdfResumeCardComponent,
  CandidateSkillsCardComponent,
  MojoExpandibleCardComponent,
  CandidateSkillComponent,
  CandidateResumeCardHeaderComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MojoCardModule,
    SharedModule,
    EffectsModule.forFeature([CandidatesEffects]),
    StoreModule.forFeature('candidatesPage', candidatesPageReducers),
    MojoExpandableCardModule,
    MojoPrivilegesModule,
    PdfViewerAdapterModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class DetailsModule {}
